
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ourhomes",
      function () {
        return require("private-next-pages/ourhomes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ourhomes"])
      });
    }
  